import coralDesktopRoutes from './coral-desktop.routes';
import coralMobileRoutes from './coral-mobile.routes';
import ladbrokesDesktopRoutes from './ladbrokes-desktop.routes';
import ladbrokesMobileRoutes from './ladbrokes-mobile.routes';
import { RoutesConfig } from './routes-config';

const routes: RoutesConfig = {
    routes: [...coralMobileRoutes.routes, ...coralDesktopRoutes.routes, ...ladbrokesMobileRoutes.routes, ...ladbrokesDesktopRoutes.routes],
};

export default routes;
